import React from 'react';

import { styled } from '@mui/material/styles';

const Container = styled('section')`
  .long-copy {
    margin-bottom: 30px;
  }
`;

type Props = {
  className?: string;
};

const About = ({ className }: Props) => (
  <Container className={className} id='about'>
    <div className='row'>
      <h2>About Us</h2>
      <p className='long-copy'>
        Locally owned and operated in Conway, SC, we provide high‑quality ready‑mix concrete backed by dependable service.
        Our team proudly serves the Conway, Myrtle Beach, and greater Horry County region, delivering the materials you
        need for projects of any size. Fully ACI and SCDOT certified, we are qualified to pour residential, commercial,
        and state‑level work throughout South Carolina.
      </p>
    </div>
  </Container>
);

export default About;
